export default {"src":"/_next/static/media/bankaccounts.f5d2d733.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};